import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import Select from "react-select";
import PhoneInput from 'react-phone-input-2';
import CheckBox from "../../../components/UI/Checkbox/CheckBox";
import { SeasonPassFieldLabel } from "../../SeasonPass/SeasonPassFieldLabel";
import { days, month, paymentMethodOptions, years } from "../../SeasonPass/constants";
import { isValidEmail } from "../../../helpers/validators";
import { getCurrentLanguageTexts } from "../../../constants/seasonPassPersonalInfoLangs";
import { SelectTickets } from "./SelectTickets";

import 'react-phone-input-2/lib/style.css';
import "../OpenSell.sass";

export const OfferSteps = ({
  tickets,
  coupon,
  pricing,
  totalFee,
  loading,
  hasSeats,
  requiredFields,
  fields,
  checkboxeFields,
  transactionData,
  eventData,
  handleChange,
  onObjectSelected,
  onObjectDeselected,
  setCouponHandler,
  showTermsAndConditionsModal,
  handleChangeCheckbox,
  theme = null,
}) => {
  const [pickerData, setPickerData] = useState({
    year: null,
    month: null,
    days: null,
  });
  const [validEmail, setValidEmail] = useState(true);
  const [blockWidth, setBlockWidth] = useState('300px');
  const blockRef = useRef(null);
  const [focusedElement, setFocusedElement] = useState(null);

  const txt = getCurrentLanguageTexts();

  const genders = [
    { label: txt.sellPageFieldsTxt["Male"], value: "Male" },
    { label: txt.sellPageFieldsTxt["Female"], value: "Female" },
  ];

  const checkIsRequired = (key) => {
    return requiredFields.some((name) => name === key) && !fields[key];
  };

  useEffect(() => {
    const isNoEmpty = Object.keys(pickerData).every((key) => !!pickerData[key]);

    if (!isNoEmpty && fields.birthday) {
      setPickerData({
        year: moment(fields.birthday).year(),
        month: moment(fields.birthday).month(),
        days: +moment(fields.birthday).format("D"),
      });
    }
  }, [fields.birthday]);

  useEffect(() => {
    setValidEmail(isValidEmail(fields.buyerEmail) || fields.buyerEmail === "");
  }, [fields.buyerEmail]);

  const handleChangeDate = (type, date) => {
    let newPickerData = { ...pickerData, [type]: date };

    setPickerData(newPickerData);

    const isNoEmpty = Object.keys(newPickerData).every(
      (key) => typeof newPickerData[key] === "number"
    );

    if (isNoEmpty) {
      const birthday = moment()
        .year(newPickerData.year)
        .month(newPickerData.month)
        .set("D", newPickerData.days)
        .toDate();

      handleChange("birthday", birthday);
    }
  };

  const handleMouseEnter = (e) => {
    if (theme && focusedElement !== e.target.name) {
      e.target.style.borderColor = theme.primarySemiLightColor;
    }
  };
  const handleMouseLeave = (e) => {
    if (theme && focusedElement !== e.target.name) {
      e.target.style.borderColor = '#f1f1f1';
    }
  };
  const handleFocusElement = (e) => {
    if (theme) {
      e.target.style.borderColor = theme.primaryColor;
      setFocusedElement(e.target.name);
    }
  }
  const handleBlureElement = (e) => {
    if (theme) {
      e.target.style.borderColor = '#f1f1f1';
    }
    setFocusedElement(null);
  };

  useEffect(() => {
    if (theme) {
      const fillFields = document.getElementById('fill-fields-offer');
      const phoneInput = fillFields.querySelector('.custom-phone-number-input');

      phoneInput.addEventListener('mouseenter', handleMouseEnter);
      phoneInput.addEventListener('mouseleave', handleMouseLeave);
    }

    if (blockRef.current) {
      setBlockWidth(
        blockRef.current.clientWidth
      )
    }
  }, [blockRef.current]);

  const themeSelectStyle = theme ? {
    control: (baseStyles, state) => ({
      ...baseStyles,
      boxShadow: "none",
      borderColor: state.isFocused ? theme.primaryColor : '#f1f1f1',
      "&:hover": {
        borderColor: state.isFocused ? theme.primaryColor : theme.primarySemiLightColor,
      },
    }),
    option: (styles, state) => ({
      ...styles,
      backgroundColor: state.isSelected ? theme.primaryColor : state.isFocused ? theme.primarySemiLightColor : "",
      "&:hover": {
        backgroundColor: state.isFocused ? theme.primarySemiLightColor : "",
      },
    })
  } : {};
  console.log(fields);
  return (
    <div className="partizan-open-selling__offerWrapper" id="fill-fields-offer">
      <div className="partizan-open-selling__offer-left-block-wrapper">
        {eventData.description && (<>
          <div className="partizan-open-selling__offer-event-description" dangerouslySetInnerHTML={{ __html: eventData.description }}>
          </div>
        </>)}
        <div className="partizan-open-selling__offer-left-block">
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Full Name"]}
            isRequired={checkIsRequired("fullName")}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
          >
            <input
              className="seasonpass__field-input"
              name="fullName"
              placeholder={txt.sellPageFieldsTxt["Enter your full name"]}
              onChange={(e) => handleChange("fullName", e.target.value)}
              onMouseEnter={handleMouseEnter}
              onFocus={handleFocusElement}
              onMouseLeave={handleMouseLeave}
              onBlur={handleBlureElement}
              type="text"
              value={fields.fullName}
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Gender"]}
            isRequired={checkIsRequired("gender")}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
          >
            <Select
              options={genders}
              name="gender"
              placeholder={txt.sellPageFieldsTxt["Select your gender"]}
              value={genders.find(({ value }) => fields.gender === value)}
              onChange={(value) => handleChange("gender", value.value)}
              styles={themeSelectStyle}
              classNamePrefix={theme ? "theme-select" : "custom-select"}
              className="partizan-open-selling__select"
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Buyer Email"]}
            isRequired={checkIsRequired("buyerEmail")}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
          >
            <input
              className="seasonpass__field-input"
              name="buyerEmail"
              placeholder={txt.sellPageFieldsTxt["Enter your email"]}
              onChange={(e) => handleChange("buyerEmail", e.target.value.trim())}
              onMouseEnter={handleMouseEnter}
              onFocus={handleFocusElement}
              onMouseLeave={handleMouseLeave}
              onBlur={handleBlureElement}
              type="text"
              value={fields.buyerEmail}
            />
            {!validEmail && (
              <span className="input-valid-error">
                {txt.sellPageFieldsTxt["This is an invalid email"]}
              </span>
            )}
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Phone Number"]}
            isRequired={checkIsRequired("phoneNumber")}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
          >
            <PhoneInput
              inputClass="custom-phone-number-input"
              buttonClass="custom-phone-number-button"
              dropdownClass={
                theme ?
                  "custom-phone-number-dropdown custom-phone-number-dropdown--theme" :
                  "custom-phone-number-dropdown"
              }
              searchClass="custom-phone-number-search"
              dropdownStyle={{ width: blockWidth }}
              searchPlaceholder={txt.dataFormTxt.countrySearchPlaceholder}
              searchNotFound={txt.dataFormTxt.countryNotFound}
              country={!fields.phoneNumber ? 'rs' : ''}
              enableSearch={true}
              disableSearchIcon={true}
              value={fields.phoneNumber || ''}
              onChange={(phone) => handleChange("phoneNumber", phone)}
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Birth Date"]}
            shouldWrapInLabel={false}
            isRequired={checkIsRequired("birthday")}
            className="partizan-open-selling__fields-label"
          >
            <div className="partizan-open-selling__picker-wrapper">
              <Select
                options={days}
                placeholder={txt.sellPageFieldsTxt["Day"]}
                value={days.find(({ value }) => pickerData.days === value)}
                onChange={(value) => handleChangeDate("days", value.value)}
                styles={themeSelectStyle}
                classNamePrefix={theme ? "theme-select" : "custom-select"}
                className="partizan-open-selling__select partizan-open-selling__select--day"
              />
              <Select
                options={month}
                placeholder={txt.sellPageFieldsTxt["Month"]}
                value={month.find(({ value }) => pickerData.month === value)}
                onChange={(value) => handleChangeDate("month", value.value)}
                styles={themeSelectStyle}
                classNamePrefix={theme ? "theme-select" : "custom-select"}
                className="partizan-open-selling__select"
              />
              <Select
                options={years}
                placeholder={txt.sellPageFieldsTxt["Year"]}
                value={years.find(({ value }) => pickerData.year === value)}
                onChange={(value) => handleChangeDate("year", value.value)}
                styles={themeSelectStyle}
                classNamePrefix={theme ? "theme-select" : "custom-select"}
                className="partizan-open-selling__select"
              />
            </div>
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Country"]}
            className="partizan-open-selling__fields-label"
            isRequired={checkIsRequired("buyerCountry")}
            shouldWrapInLabel={false}
          >
            <Select
              options={txt.BuySeasonPassModalTxt.companyCountryOptions}
              name="buyerCountry"
              placeholder={txt.sellPageFieldsTxt["Select country"]}
              value={txt.BuySeasonPassModalTxt.companyCountryOptions.find(
                ({ value }) => fields.buyerCountry === value
              )}
              onChange={(value) => handleChange("buyerCountry", value.value)}
              styles={themeSelectStyle}
              classNamePrefix={theme ? "theme-select" : "custom-select"}
              className="partizan-open-selling__select"
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["City"]}
            isRequired={checkIsRequired("city")}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
          >
            <input
              className="seasonpass__field-input"
              name="city"
              placeholder={txt.sellPageFieldsTxt["Enter your city"]}
              onChange={(e) => handleChange("city", e.target.value)}
              onMouseEnter={handleMouseEnter}
              onFocus={handleFocusElement}
              onMouseLeave={handleMouseLeave}
              onBlur={handleBlureElement}
              type="text"
              value={fields.city}
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Street and House Number"]}
            isRequired={checkIsRequired("physicalAddress")}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
          >
            <input
              className="seasonpass__field-input"
              placeholder={txt.sellPageFieldsTxt["Enter your street and house number"]}
              name="physicalAddress"
              onChange={(e) => handleChange("physicalAddress", e.target.value)}
              onMouseEnter={handleMouseEnter}
              onFocus={handleFocusElement}
              onMouseLeave={handleMouseLeave}
              onBlur={handleBlureElement}
              type="text"
              value={fields.physicalAddress}
              ref={blockRef}
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Postal Code"]}
            isRequired={checkIsRequired("postalCode")}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
          >
            <input
              className="seasonpass__field-input seasonpass__field-input--postalCode"
              name="postalCode"
              placeholder={txt.sellPageFieldsTxt["Enter your postal code"] || 'fsdf'}
              onChange={(e) => handleChange("postalCode", e.target.value)}
              onMouseEnter={handleMouseEnter}
              onFocus={handleFocusElement}
              onMouseLeave={handleMouseLeave}
              onBlur={handleBlureElement}
              type="text"
              value={fields.postalCode}
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Company Vat Number"]}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
            isRequired={(!!fields.companyName && !!fields.companyName.trim() && !fields.companyVatNumber && !fields.companyVatNumber.trim())}
          >
            <input
              className="seasonpass__field-input"
              name="companyVatNumber"
              placeholder={txt.sellPageFieldsTxt["Enter company vat number"]}
              onChange={(e) => handleChange("companyVatNumber", e.target.value)}
              onMouseEnter={handleMouseEnter}
              onFocus={handleFocusElement}
              onMouseLeave={handleMouseLeave}
              onBlur={handleBlureElement}
              type="text"
              value={fields.companyVatNumber}
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageFieldsTxt["Company Name"]}
            className="partizan-open-selling__fields-label"
            shouldWrapInLabel={false}
            isRequired={(!!fields.companyName && !fields.companyName.trim() && !!fields.companyVatNumber && !!fields.companyVatNumber.trim())}
          >
            <input
              className="seasonpass__field-input"
              name="companyName"
              placeholder={txt.sellPageFieldsTxt["Enter company company name"]}
              onChange={(e) => handleChange("companyName", e.target.value)}
              onMouseEnter={handleMouseEnter}
              onFocus={handleFocusElement}
              onMouseLeave={handleMouseLeave}
              onBlur={handleBlureElement}
              type="text"
              value={fields.companyName}
            />
          </SeasonPassFieldLabel>
          <SeasonPassFieldLabel
            label={txt.sellPageTxt["Payment method"]}
            isRequired={true}
            className="partizan-open-selling__payment-method"
            shouldWrapInLabel={false}
          >
            <Select
              options={eventData.allowedPaymentProviders.flatMap(p => {
                return p.methods.map(m => {
                  return {
                    id: p.providerId,
                    value: paymentMethodOptions[p.providerId],
                    label: m.name,
                  }
                })
              })}
              name="paymentMethod"
              value={eventData.allowedPaymentProviders.flatMap(p => {
                return p.methods.map(m => {
                  return {
                    id: p.providerId,
                    value: paymentMethodOptions[p.providerId],
                    label: m.name,
                  }
                })
              }).find(
                ({ value }) => fields.paymentMethod.id === value.id
              )}
              onChange={(value) => handleChange("paymentMethod", value)}
              styles={themeSelectStyle}
              classNamePrefix={theme ? "theme-select" : "custom-select"}
              className="partizan-open-selling__select"
            />
          </SeasonPassFieldLabel>
          <CheckBox
            checked={checkboxeFields.termsAndConditionsChecked}
            id="terms-and-conditions-checkbox"
            name="terms-and-conditions-checkbox"
            onChange={() => handleChangeCheckbox("termsAndConditionsChecked")}
          >
            <span className="partizan-open-selling__text-medium-small">
              {txt.sellPageTxt["I agree with"]}
              <span
                className="partizan-open-selling__terms-of-service-text"
                onClick={showTermsAndConditionsModal}
                style={{
                  color: theme ? theme.secondaryColor : '',
                }}
              >
                {txt.sellPageTxt["Terms of Service"]}
              </span>
            </span>
          </CheckBox>
        </div>
      </div>

      <div className="partizan-open-selling__offer-right-block">
        <SelectTickets
          totalFee={totalFee}
          isOffers
          tickets={tickets}
          ticketTemplates={eventData.ticketTemplates}
          pricing={pricing}
          hasSeats={hasSeats}
          workspaceKey={eventData.seatsIoWorkspaceId}
          eventSeatsId={eventData.seatsIoEventId}
          event={eventData}
          loading={loading}
          currency={transactionData.currencyCode}
          onObjectSelected={onObjectSelected}
          onObjectDeselected={onObjectDeselected}
          total={transactionData.paymentAmount}
          setCouponHandler={setCouponHandler}
          coupon={coupon}
          theme={theme}
          isTermsChecked={checkboxeFields.termsAndConditionsChecked}
          handleChangeCheckbox={handleChangeCheckbox}
          showTermsAndConditionsModal={showTermsAndConditionsModal}
          isTermsCheckbox={false}
        />
      </div>
    </div>
  )
};
